import React from "react";
import { connect } from "react-redux";

import Box from "./Box";
import Row from "./Row";
import Address from "../../DataEntry/Address";
import GPS from "../../DataEntry/GPS";
import Select from "../../DataEntry/Select";

class ShippingAddress extends React.Component<any, any> {
  state = null;

  constructor(props: any) {
    super(props);
    this.state = {
      searching: false,
      valid: props.formik.values.shipping_address_valid.toString() == "true",
    };
  }

  componentDidUpdate(prevProps: any, _prevState: any) {
    const valid = this.props.formik.values.shipping_address_valid.toString();

    if (
      prevProps.formik.values.shipping_address_valid.toString() !== valid &&
      this.state.valid.toString() !== valid
    ) {
      this.setState({
        valid: this.props.formik.values.shipping_address_valid,
      });
    }
  }

  handleValidateAddress = (meta: any, place: any) => {
    const { formik } = this.props;

    formik.setFieldValue("shipping_address_valid", meta.valid);
    this.setState({ valid: meta.valid });

    formik.setFieldValue("shipping_city", meta.city);
    formik.setFieldValue("shipping_state", meta.state);
    formik.setFieldValue("shipping_zip", meta.zip);
    formik.setFieldValue("shipping_country", meta.country);
    formik.setFieldValue("shipping_address", meta.address);
    formik.setFieldValue("shipping_gps", `${meta.latitude},${meta.longitude}`);
    formik.setFieldValue(
      "shipping_formatted_address",
      place.address.formattedAddress,
    );
  };

  render() {
    const {
      formik: { isSubmitting },
      viewOnly,
    } = this.props;
    const { searching, valid } = this.state;

    const alarm = (
      <i
        className="fa fa fa-warning textOrange pointer"
        title="The address is not valid! "
        data-toggle="tooltip"
        data-placement="top"
        style={{ paddingRight: "10px", paddingTop: "8px" }}
      />
    );

    return (
      <Box title="Shipping Address">
        <Row
          component={Select}
          md={2}
          label="Country"
          list={[["us", "United States"]]}
          name="shipping_country"
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row
          component={Address}
          md={2}
          label="Search"
          name="shipping_formatted_address"
          placeholder="Search for location ..."
          onStartSearching={() => this.setState({ searching: true })}
          onFinishSearching={() => this.setState({ searching: false })}
          onValidateAddress={this.handleValidateAddress}
          disabled={viewOnly || isSubmitting}
        />
        <Row
          md={2}
          label="Address"
          name="shipping_address"
          alarm={!valid && alarm}
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row md={2} label="Address 2" name="shipping_address2" />
        <Row
          md={2}
          label="City"
          name="shipping_city"
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row
          md={2}
          label="State"
          name="shipping_state"
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row
          md={2}
          label="ZIP"
          name="shipping_zip"
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row
          md={2}
          label="GLN"
          name="shipping_gln"
          disabled={searching || viewOnly || isSubmitting}
        />
        <Row
          md={2}
          label="GPS"
          linkToMap
          name="shipping_gps"
          component={GPS}
          disabled={searching || viewOnly || isSubmitting}
        />
      </Box>
    );
  }
}

const mapStateToProps = (_state: any, _props: any) => ({});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddress);
